/**
 * «Человек сделал то, ради чего нужны уведомления».
 *
 * Android 13+ даёт приложению ровно две попытки показать системный диалог: после первого отказа
 * `shouldShowRequestPermissionRationale` ещё вернёт `true`, после второго — уже никогда, и
 * единственной дорогой остаются системные настройки. Поэтому момент вопроса важнее его текста.
 *
 * Спрашиваем не при запуске, а после первого действия, которое означает «я жду ответа»:
 * отправил сообщение, создал заявку, откликнулся на чужую, вошёл в сессию. В этот момент польза
 * очевидна без объяснений, и согласие даётся охотно — так же рекомендует и Google, и так делают
 * приложения, которым есть что терять.
 *
 * Флаг живёт в памяти вкладки, а не в хранилище, и это сознательно: он значит не «когда-то
 * что-то делал», а «сейчас ждёт ответа». Перезапустил приложение — ждём нового повода.
 *
 * На Android 12 и ниже всё это не нужно: разрешения там нет, токен забирается молча
 * (`useSilentPushRegistration`), и до этого модуля дело не доходит.
 */
let armed = false;

const listeners = new Set<() => void>();

/**
 * Отметить действие. Зовётся из моделей — по одному месту на операцию, чтобы отметка не зависела
 * от того, с какого экрана человек нажал кнопку.
 */
export const notePushWorthyAction = () => {
  if (armed) {
    return;
  }
  armed = true;
  listeners.forEach((notify) => notify());
};

export const isPushPromptArmed = () => armed;

export const subscribePushPrompt = (listener: () => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

/** Только для тестов: флаг живёт в модуле и переживает отдельные проверки. */
export const resetPushPrompt = () => {
  armed = false;
  listeners.clear();
};
